import { APP_SETTINGS_VERSION_LATEST } from 'wix-vod-shared/src/app-settings/constants/versions';
import { isDemoChannel } from 'shared/utils/channel-helpers';

export const isLatestVersion = appSettings =>
  _.get(appSettings, 'numbers.settingsVersion') === APP_SETTINGS_VERSION_LATEST;

export const isNewInstallation = appSettings => {
  const channelId = _.get(appSettings, 'fonts.channelId');
  return !channelId || isDemoChannel(channelId);
};



// WEBPACK FOOTER //
// ./src/shared/utils/app-settings.js